import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom"; // For navigation

const Home = () => {
  return (
    <div
      className="home-page"
      style={{
        backgroundImage: "url('runpodds.jpg')", // Update with correct path
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        color: "white", // Ensure text is readable
        textAlign: "center", // Center text for all screen sizes
        padding: "5vh 5vw", // Responsive padding
      }}
    >
      {/* Hero Section */}
      <section style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div>
          <h1 style={{ fontSize: "10vw", fontWeight: "bold",marginTop:"130px" }}>All in one cloud.</h1>
          <p style={{ fontSize: "2vw", maxWidth: "80vw", margin: "auto" }}>
            Train, fine-tune and deploy AI 
          </p>
          <p style={{ fontSize: "2vw", maxWidth: "80vw", margin: "auto" }}>
             models with Defcon.
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section py-5">
        <Container>
          <h2 className="text-center mb-5" style={{ fontSize: "3vw" }}>Why Choose Us?</h2>
          <Row>
            {/* Feature 1 */}
            <Col md={4} sm={12} className="mb-4">
              <Card className="h-100 text-center">
                <Card.Body>
                  <div className="display-4 mb-3">🚀</div>
                  <Card.Title>High-Performance GPUs</Card.Title>
                  <Card.Text>Access the latest NVIDIA GPUs for your AI workloads.</Card.Text>
                </Card.Body>
              </Card>
            </Col>

            {/* Feature 2 */}
            <Col md={4} sm={12} className="mb-4">
              <Card className="h-100 text-center">
                <Card.Body>
                  <div className="display-4 mb-3">📈</div>
                  <Card.Title>Scalable Infrastructure</Card.Title>
                  <Card.Text>Easily scale up or down based on your needs.</Card.Text>
                </Card.Body>
              </Card>
            </Col>

            {/* Feature 3 */}
            <Col md={4} sm={12} className="mb-4">
              <Card className="h-100 text-center">
                <Card.Body>
                  <div className="display-4 mb-3">💻</div>
                  <Card.Title>Easy to Use</Card.Title>
                  <Card.Text>Simple interface and APIs for seamless integration.</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Call-to-Action Section */}
      <section className="cta-section py-5" style={{borderRadius: "10px", padding: "20px" ,marginTop:"-30px"}}>
        <Container>
          <Row className="text-center">
            <Col>
              <h2 className="mb-4" style={{ fontSize: "2.5vw" }}>Ready to Get Started?</h2>
              <Button as={Link} to="/signup" variant="primary" size="lg" className="me-3">
                GET STARTED
              </Button>
              <Button as={Link} to="/contact-sales" variant="outline-primary" size="lg">
                Contact Sales
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Home;
